// extracted by mini-css-extract-plugin
export var active = "_l0-e";
export var blink = "_l0-f";
export var dropDownSelector = "_l0-5";
export var dropDownWrapper = "_l0-4";
export var fakeCursor = "_l0-d";
export var fontSizeButton = "_l0-7";
export var formQuillEditor = "_l0-0";
export var pressed = "_l0-g";
export var qlBlank = "_l0-1";
export var textFormattingToolbar = "_l0-2";
export var textFormattingToolbarClosed = "_l0-3";
export var textFormattingToolbarInline = "_l0-6";
export var textToolbarOption = "_l0-8";
export var toolbarCell = "_l0-a";
export var toolbarCellCollapsed = "_l0-b";
export var toolbarOptionHitArea = "_l0-c";
export var toolbarOverflow = "_l0-9";